import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const ScrollToTopButton = () => { 
  const {i18n} = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className={`fixed bottom-10 ${ i18n.language === 'ar' ? "left-10" : "right-10"} z-[20]`}>
      {isVisible && (
        <div className="group scroll-to-top-button">
          <button
            onClick={scrollToTop}
            className="p-3 bg-[#ff014f] text-white rounded-full shadow-lg hover:bg-white transition-all duration-300 group-hover:text-[#ff014f]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 group-hover:stroke-[#ff014f] stroke-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 10l7-7m0 0l7 7m-7-7v18"
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default ScrollToTopButton;  // تصدير كمكون